var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('router-link',{staticClass:"mr-3 btn btn-info",attrs:{"to":{
      path: ("/Region/service/transactions/" + (_vm.data.companyServiceId)),
      query: {
        serviceName: _vm.data.companyService,
        serviceId: _vm.data.id,
        branchId: _vm.$route.query.branchId,
        companyId: _vm.$route.query.companyId,
        regionId: _vm.$route.query.regionId,
      },
    }}},[_vm._v("\n     "+_vm._s(_vm.$t('text.clickButtons.transactionHistory'))+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }